import { Loader } from "@googlemaps/js-api-loader";

export function loadPlacesLibrary(apiKey: string): Promise<google.maps.PlacesLibrary> {
	return new Loader({
		apiKey,
		libraries: ["places"],
		language: "en",
		region: "US"
	}).importLibrary("places");
}
